(() => {
  const initialize = scope => {
    const forms = [...scope.querySelectorAll('[data-rrgp-lamp-calculator]')];
    if (scope.matches?.('[data-rrgp-lamp-calculator]')) forms.push(scope);
    forms.forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.hidden = false;
      form.addEventListener('submit', event => {
        event.preventDefault();
        const tableInput = form.querySelector('[name="table"]');
        const eyeInput = form.querySelector('[name="eye"]');
        const table = Number(tableInput.value);
        const eye = Number(eyeInput.value);
        const output = form.querySelector('output');
        if (!tableInput.value || !eyeInput.value || !form.checkValidity() || !Number.isFinite(table) || !Number.isFinite(eye) || eye <= table) {
          output.classList.add('error');
          output.textContent = form.dataset.error;
          return;
        }
        output.classList.remove('error');
        const number = document.createElement('strong');
        number.textContent = (Math.round((eye - table) * 10) / 10) + '\u2033';
        const label = document.createElement('span');
        label.textContent = form.dataset.result;
        output.replaceChildren(number, label);
      });
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
